import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './constants/locales/en/translation.json';
import translationSV from './constants/locales/sv/translation.json';

const resources = {
  en: {
    translation: translationEN,
  },
  sv: {
    translation: translationSV,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
